/*
 * src/components/AlertBanner/index.js
 * Description: Generic alert banner with success, warn, error, and info states
 * Copyright (c) 2021 PredictiveUX
 */
import React, { useState } from "react";

import css from "./AlertBanner.module.css";

const AlertBanner = ({ alertType = "info", text, show = true }) => {
  const [visible, setVisible] = useState(show);

  return (
    <div className={css.alert} style={{ display: visible ? "block" : "none" }}>
      <div className={css[alertType]}>
        <div className={css.text}>{text}</div>
        <div
          className={css.closeIcon}
          role="button"
          tabIndex="0"
          onClick={() => setVisible(false)}
        >
          <span className={css[alertType]}>X</span>
        </div>
      </div>
    </div>
  );
};

export default AlertBanner;
